import { useDebouncedCallback } from 'use-debounce';

import { AUCTION_HOUSE_TYPEAHEAD_DEBOUNCE_MS } from '@/pages/Search/SearchPage/types';
import { useAppDispatch } from '@/redux/hooks';
import { fetchAuctionHouseTypeahead } from '@/redux/modules/search/search.actions';

/**
 * Returns a debounced callback that fires the server-side AuctionHouse
 * search-as-you-type request. Caller invokes with the latest input value
 * on every change; whitespace-only input is a no-op (the component falls
 * back to rendering the default `auctionHouse` facet options).
 *
 * Debounce keeps bursty typing from generating one request per keystroke;
 * "latest dispatch wins" semantics let Redux replace `state.facets`
 * naturally when responses interleave.
 */
export const useDebouncedAuctionHouseTypeahead = () => {
    const dispatch = useAppDispatch();

    return useDebouncedCallback((searchString: string) => {
        if (searchString.trim() === '') {
            return;
        }
        dispatch(fetchAuctionHouseTypeahead({ searchString }));
    }, AUCTION_HOUSE_TYPEAHEAD_DEBOUNCE_MS);
};
